module.exports = __webpack_public_path__ + "img/九州机构通客户操作手册12600.e5d3fcf8.png";